import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ConfigService } from 'src/app/core/service/config.service';
import { BidderList } from 'src/app/features/multi-auction-bidder/core/modal/bidders-list';
import { ListModal } from 'src/app/features/multi-auction-bidder/core/modal/list-modal';
import { RemainingTimeBetweenModal } from 'src/app/features/multi-auction-bidder/core/modal/remaining-time-between-modal';
import { RoomDetailesModal } from 'src/app/features/multi-auction-bidder/core/modal/roomDetailes-modal';
import * as moment from 'moment';

@Component({
  selector: 'app-multi-live-bidding',
  templateUrl: './multi-live-bidding.component.html',
  styleUrls: []
})
export class MultiLiveBiddingComponent implements OnInit {
  @Input() roomdetails!: RoomDetailesModal;
  @Input() itemDetails: ListModal | undefined;
  @Input() activeAuctionWork: any;
  @Input() auctionRemainingTime: any;
  @Input() auctionRemainingTimeBetween: RemainingTimeBetweenModal | undefined;
  @Input() auctionRemainingTimeNoBid: RemainingTimeBetweenModal | undefined;
  @Input() listBidders: any;
  @Input() auctionPause: any;
  @Input() isLastItem: boolean = false;
  @Output() newBidding = new EventEmitter<any>();
  @Output() userJoined = new EventEmitter<boolean>();




  joind = false;
  winner = false;
  userInfo: any;
  lastPrice: any;
  itemNotOpen = false;
  auctionWillBeStart = true;
  timeStart: any;
  remainingTimeMinutes = 0;
  remainingTimeSeconds = 0;
  constructor(public _config: ConfigService) {
    this.userInfo = _config.getAuthUserInfo();
  }


  ngOnInit() {

    this.joind = this.roomdetails.is_me_joined;
    // this.auctionPause = this.roomdetails.is_pause;

    this.checkWinner();
    this.checkReminingBetween();
  }

  ngOnChanges(changes: any): void {
    this.auctionWillBeStart = false;
    if ('auctionRemainingTime' in changes) {

      if (this.auctionRemainingTime == 0) {
        this.itemDetails!.is_closed = 1;
        this.checkWinner();
      }
    }

    if ('auctionRemainingTimeNoBid' in changes) {
      if (changes.auctionRemainingTimeNoBid.previousValue) {
        if (changes.auctionRemainingTimeNoBid.currentValue.remainingStart == 0 && this.auctionRemainingTime == 0) {
          this.itemDetails!.is_closed = 1;
          this.checkWinner();
        }

        // if (changes.auctionRemainingTimeNoBid.currentValue.remainingStart == 0 && this.auctionRemainingTime == 90) {
        //   this.itemDetails!.is_closed = 1;
        //   this.checkWinner();
        // }

      }


    }

    if ('auctionRemainingTimeBetween' in changes) {
      this.checkReminingBetween();

    }

    if ('itemDetails' in changes) {

      this.winner = false;

      if (changes.itemDetails.previousValue) {
        if (this.activeAuctionWork && this.activeAuctionWork != this.itemDetails?.id && !this.itemDetails?.is_closed) {
          // debugger
          this.itemNotOpen = true;
          this.auctionWillBeStart = false;
        } else {
          this.itemNotOpen = false
        }

        if (this.itemDetails?.is_closed) {
          this.checkWinner();
        }

      }

      if (this.auctionRemainingTime == 0 && this.isLastItem) {

      }

    }

    if ('listBidders' in changes) {
      this.checkWinner();
    }

    // if ('auctionPause' in changes) {
    //   if (changes.auctionPause.previousValue) {
    //     this.auctionPause = changes.auctionPause.currentValue;
    //   }
    // }

    if ('roomdetails' in changes) {
      this.joind = this.roomdetails.is_me_joined;
      // this.auctionPause = this.roomdetails.is_pause;
    }

    this.checkWinner();
    this.checkReminingBetween();


  }

  newBiddingListener(data: any) {
    this.newBidding.emit(data);
  }

  checkWinner() {
    if (this.listBidders) {
      if (this.listBidders.length) {
        this.winner = (this.listBidders[0].userID == this.userInfo.user.id && this.itemDetails?.is_closed) ? true : false;
        this.lastPrice = this.listBidders[0].price;
        this.itemNotOpen = false;
      } else {
        this.lastPrice = 0;
        if (this.itemDetails?.is_closed) {
          this.winner = false;
          this.itemNotOpen = false;
        } else {

        }


      }
    }

  }

  checkReminingBetween() {

    if (this.auctionRemainingTimeBetween) {
      if (this.auctionRemainingTimeBetween?.remainingStart == 0 || this.activeAuctionWork != this.itemDetails?.id) {
        this.auctionWillBeStart = false;
      }
      if (this.auctionRemainingTimeBetween?.remainingStart > 0 && this.activeAuctionWork == this.itemDetails?.id) {
        this.auctionWillBeStart = true;
        this.remainingTimeMinutes = Math.floor(this.auctionRemainingTimeBetween?.remainingStart / 60);
        this.remainingTimeSeconds = this.auctionRemainingTimeBetween!.remainingStart % 60;
      }
    }
  }


}
